import { render, staticRenderFns } from "./LedgerMobile.vue?vue&type=template&id=562c31ca"
import script from "./LedgerMobile.vue?vue&type=script&lang=js"
export * from "./LedgerMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports